/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { BuyOmButtonIcon } from '../constants/icon-constants';

import styles from './buy-crypto.module.scss';

function ScrollDialog({ buttonText, dialogTitle, isNeedToShowOmIcon = false }) {
  const [open, setOpen] = useState(false);
  const [scroll] = useState('paper');

  const descriptionElementRef = useRef(null);

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const handleClickOpen = () => () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  return (
    <div className={styles.container}>
      <button className={styles.button} onClick={handleClickOpen()}>
        <span>
          {buttonText}
          {isNeedToShowOmIcon && BuyOmButtonIcon}
        </span>
      </button>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby='scroll-dialog-title'
        aria-describedby='scroll-dialog-description'
      >
        <DialogTitle id='scroll-dialog-title'>{dialogTitle}</DialogTitle>
        <DialogContent dividers>
          <iframe
            title='Buy staging'
            allow='accelerometer; autoplay; camera; gyroscope; payment'
            frameBorder='0'
            height='550px'
            style={{ overflow: 'scroll' }}
            src='https://buy.moonpay.io?apiKey=pk_live_Ysu0KwECvBna1poHfeF1REIOsJUYTbMN&colorCode=%23EB1A6B'
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary'>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ScrollDialog.propTypes = {
  buttonText: PropTypes.string,
  dialogTitle: PropTypes.string,
  isNeedToShowOmIcon: PropTypes.bool,
};

ScrollDialog.defaultProps = {
  buttonText: '',
  dialogTitle: '',
  isNeedToShowOmIcon: false,
};

export default ScrollDialog;
